import { MerchantPaneContainer } from './MerchantPane.styled'

import { findCurrencyPrecision, formatFloat } from 'mmfintech-commons'

type MerchantPaneProps = {
  session: any
  logo?: string
}

export const MerchantPane = ({ session }: MerchantPaneProps) => {
  if (session) {
    const { amount, currency, foreignTransactionId /*, merchantName*/ } = session || {}

    return (
      <MerchantPaneContainer>
        {/*

        Removed by Svilen's request on 24.2.2025 11:35 (no Jira)

        <span className='merchant-pane-pay-to-title'>{`${tr(
          'CHECKOUT.PAYMENT.PAY_TO',
          'Pay to'
        )} ${merchantName}`}</span>*/}
        <div className='merchant-amount-container'>
          <div className='amount-wrapper'>
            <span className='value'>{formatFloat(amount, findCurrencyPrecision(currency))}</span>
            <span className='currency'>{currency}</span>
          </div>
          <span className='foreign-transaction-text'>{foreignTransactionId}</span>
        </div>
      </MerchantPaneContainer>
    )
  }

  return null
}
